import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import { addToCart, removeFromWish } from '../actions/wishCompareCart';
import { withTranslation } from 'react-i18next';
import i18n from 'i18next';
import UIkit from 'uikit';
import Footer from './footer';
import loader from '../images/loader.svg';
import defImage from '../images/not-image.png';
import cartIcon from '../images/cart-icon.svg';
import deleteIcon from '../images/delete-icon.svg';
import { config } from '../config';
import { Helmet } from 'react-helmet';

/**
 * Just a wrapper under list items
 *
 */
class Wishlist extends Component {
  static propTypes = {
    wishList: PropTypes.array,
    isShowCompareCartWishLoader: PropTypes.bool,
    countProductsToAdd: PropTypes.number,
  };

  render() {
    const { t } = this.props;
    return (
      <div className='uk-container'>
        <header>
          <Helmet>
            <meta charSet='utf-8' />
            <title>{t('wishlist')}</title>
          </Helmet>
        </header>
        <div
          className={this.props.isShowCompareCartWishLoader ? '' : 'uk-hidden'}
        >
          <div className='loader-overlay  uk-position-fixed uk-position-z-index'>
            <div className='uk-position-center'>
              <img src={loader} uk-svg='' alt={'loading...'} />
            </div>
          </div>
        </div>

        <div>
          <div className='uk-margin-top'>
            <h1 className='page-title uk-text-bold'>{t('wishlist')}</h1>
          </div>
          <div>
            <table className='cart-table'>
              <thead>
                <tr>
                  <th>{t('cart._table_image')}</th>
                  <th>{t('cart._table_name')}</th>
                  <th>{t('cart._table_price')}</th>
                  <th></th>
                  <th></th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {this.props.wishList !== undefined
                  ? this.props.wishList.countItem > 0
                    ? Object.keys(this.props.wishList.data).map((itm) => (
                        <tr className='cart-product'>
                          <td className='uk-text-center uk-padding-small'>
                            <img
                              className='cart-product__image'
                              src={
                                config.assetsPrfix +
                                'img/products/minB_' +
                                this.props.wishList.data[itm].image
                              }
                              title={this.props.wishList.data[itm].productName}
                              alt={this.props.wishList.data[itm].productName}
                              onError={(e) => {
                                e.target.onerror = null;
                                e.target.src = defImage;
                              }}
                            />
                          </td>
                          <td>
                            <Link
                              className='cart-product__name'
                              to={
                                `/products/${
                                  i18n.language +
                                  '/' +
                                  this.props.wishList.data[itm].category
                                }` +
                                '/item/' +
                                this.props.wishList.data[itm].productId
                              }
                            >
                              {this.props.wishList.data[itm].productName}
                            </Link>
                          </td>
                          <td className='cart-product__price'>
                            <span className='cart-product__mob-text uk-hidden@m'>
                              {t('cart._table_price')}:
                            </span>
                            {this.props.wishList.data[itm].priceTotal}
                          </td>
                          <td className='cart-product__addtocart uk-text-center'>
                            <div
                              onClick={(e) =>
                                this.props.addToCart(
                                  this.props.wishList.data[itm].productId
                                )
                              }
                              className={'product-addtocart uk-button'}
                              title={t('item.add_tocart')}
                            >
                              {t('item.add_tocart')}
                            </div>
                          </td>
                          <td>
                            <div className='cart-product__remove-btn uk-padding-small'>
                              <div
                                onClick={(e) =>
                                  this.props.removeFromWish(
                                    this.props.wishList.data[itm].productId,
                                    this.props.wishList.data[itm].productName,
                                    t('wishlist.msgShureRemove'),
                                    t('wishlist.msgYes'),
                                    t('wishlist.msgNo')
                                  )
                                }
                                title={t('item.remove_from_cart')}
                              >
                                <img
                                  src={deleteIcon}
                                  uk-svg={''}
                                  alt={t('item.remove_from_cart')}
                                />
                              </div>
                            </div>
                          </td>
                        </tr>
                      ))
                    : ''
                  : ''}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    );
  }
}

const ProductsWishlist = withTranslation('translations')(Wishlist);

const mapStateToProps = (store) => {
  const { wishData, isShowCompareCartWishLoader } = store.wishCompareCart;
  const { countProductsToAdd } = store.goodItem;
  return {
    wishList: wishData,
    isShowCompareCartWishLoader,
    countProductsToAdd,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    addToCart: (id) => {
      dispatch(addToCart(id, false));
    },
    removeFromWish: (id, itemName, msgShureRemove, msgYes, msgNo) => {
      UIkit.modal
        .confirm(
          '<p class="uk-text-emphasis">' +
            msgShureRemove +
            ` ${itemName}` +
            '</p>',
          { labels: { ok: msgYes, cancel: msgNo } }
        )
        .then(function () {
          dispatch(removeFromWish(id));
        });
    },
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(ProductsWishlist);
